import './Main/admin/admin.tpl.html';
import './Main/admin/adminBusinessUnits/businessUnit.full.tpl.html';
import './Main/admin/adminBusinessUnits/businessUnit.nav.list.childrenItem.tpl.html';
import './Main/admin/adminBusinessUnits/businessUnit.nav.parentItem.tpl.html';
import './Main/admin/adminBusinessUnits/businessUnitEdit.tpl.html';
import './Main/admin/adminBusinessUnits/businessUnits.tpl.html';
import './Main/admin/adminBusinessUnits/searchEmployee.tpl.html';
import './Main/admin/adminDefaultEntitlement/AddDefaultEntitlement.tpl.html';
import './Main/admin/adminDefaultEntitlement/BySystemRole.tpl.html';
import './Main/admin/adminDefaultEntitlement/MainDefaultEntitlement.tpl.html';
import './Main/admin/adminDefaultEntitlement/ViewExistingRights.tpl.html';
import './Main/admin/adminDefaultEntitlement/ViewSelectedSystemRole.tpl.html';
import './Main/admin/adminDefaultEntitlement/ViewSupervisorDetails.tpl.html';
import './Main/admin/adminEmailTemplates/EditEmailTemplate.tpl.html';
import './Main/admin/adminEmailTemplates/EmailTemplate.tpl.html';
import './Main/admin/adminEmailTemplates/MainEmailTemplates.tpl.html';
import './Main/admin/adminEmailTemplates/SideBar.tpl.html';
import './Main/admin/adminEmailTemplates/SideBar_EmailTemplate.tpl.html';
import './Main/admin/adminSupervisorReview/AdminSupervisorAccessReview.tpl.html';
import './Main/admin/adminSupervisorReview/ConfirmDialogSupervisorReminder.tpl.html';
import './Main/admin/adminSupervisorReview/SupervisorCard.tpl.html';
import './Main/admin/adminSystemOwnerReview/Administration.tpl.html';
import './Main/admin/adminSystemOwnerReview/SystemOwnerCard.tpl.html';
import './Main/admin/Admin_Actions.tpl.html';
import './Main/employee/contactInfo.tpl.html';
import './Main/employee/contactInfo_Primary.tpl.html';
import './Main/employee/contactInfo_Secondary.tpl.html';
import './Main/employee/employee.tpl.html';
import './Main/employee/employeePasswordReset.tpl.html';
import './Main/employee/employeePositionInHierarchyModal.tpl.html';
import './Main/employee/employeePreAuthorizations.tpl.html';
import './Main/employee/employeeSidebar.tpl.html';
import './Main/employee/employeeSidebarHelp.tpl.html';
import './Main/employee/employeeSidebarHelpGeneric.tpl.html';
import './Main/employee/employeeSummary.tpl.html';
import './Main/employee/employeeSummary_History.tpl.html';
import './Main/employee/employeeSummary_History_AccessCardUpdate.tpl.html';
import './Main/employee/employeeSummary_History_AccountNameChange.tpl.html';
import './Main/employee/employeeSummary_History_OtherEmployeeMovements.tpl.html';
import './Main/employee/employeeSummary_History_PasswordReset.tpl.html';
import './Main/employee/employeeSummary_History_UserRequest.tpl.html';
import './Main/employee/employeeSummary_OperationalTasks.ChangeTransferModal.tpl.html';
import './Main/employee/employeeSummary_OperationalTasks.tpl.html';
import './Main/employee/EmployeeSystemBusinessTasks.tpl.html';
import './Main/employee/passwordReset_SelectSystemModal.tpl.html';
import './Main/home/FeatureMyProfile.tpl.html';
import './Main/home/home.tpl.html';
import './Main/hr/confirmations/batchConfirmByRuleModal.tpl.html';
import './Main/hr/confirmations/confirmations.tpl.html';
import './Main/hr/confirmations/confirmations_Facets.tpl.html';
import './Main/hr/confirmations/confirmations_InProgress.tpl.html';
import './Main/hr/confirmations/confirmations_Paging-footer.tpl.html';
import './Main/hr/confirmations/confirmations_Paging.tpl.html';
import './Main/hr/confirmations/confirmations_Summary.tpl.html';
import './Main/hr/confirmations/employeeSync.tpl.html';
import './Main/hr/HR.tpl.html';
import './Main/itPurchasing/ItPurchasing.tpl.html';
import './Main/itPurchasing/itPurchasingActions.tpl.html';
import './Main/itPurchasing/itPurchasingAssign.tpl.html';
import './Main/itPurchasing/itPurchasingAssignMultiSelect.tpl.html';
import './Main/itPurchasing/itPurchasingMultiSelectActions.tpl.html';
import './Main/itPurchasing/itPurchasingOrdering.tpl.html';
import './Main/itPurchasing/itPurchasingStatusFilters.tpl.html';
import './Main/itPurchasing/itPurchasingSystemCard.tpl.html';
import './Main/selfAccessRequest/adHoc/AdHoc.tpl.html';
import './Main/selfAccessRequest/adHoc/AdHocAdditionalSteps.html';
import './Main/selfAccessRequest/adHoc/otherCatalog/OtherCatalog.tpl.html';
import './Main/selfAccessRequest/adHoc/preAuthorized/NoDecisionsModal.tpl.html';
import './Main/selfAccessRequest/adHoc/preAuthorized/PreAuthorized.tpl.html';
import './Main/selfAccessRequest/adHoc/preAuthorized/PreAuthorized_FlowButtons.tpl.html';
import './Main/selfAccessRequest/adHoc/preAuthorized/PreAuthorized_Footer.tpl.html';
import './Main/selfAccessRequest/adHoc/preAuthorized/PreAuthorized_Header.tpl.html';
import './Main/selfAccessRequest/adHoc/preAuthorized/PreAuthorizedExplanation1.tpl.html';
import './Main/selfAccessRequest/adHoc/removeRights/adhocWelcome.tpl.html';
import './Main/selfAccessRequest/adHoc/removeRights/NoDecisionsModal.tpl.html';
import './Main/selfAccessRequest/adHoc/removeRights/RemoveRights.tpl.html';
import './Main/selfAccessRequest/adHoc/removeRights/RemoveRights_FlowButtons.tpl.html';
import './Main/selfAccessRequest/adHoc/removeRights/RemoveRights_Footer.tpl.html';
import './Main/selfAccessRequest/adHoc/removeRights/RemoveRights_Header.tpl.html';
import './Main/selfAccessRequest/adHoc/sameAs/SameAs.tpl.html';
import './Main/selfAccessRequest/adHoc/sameAs/SameAs_FlowButtons.tpl.html';
import './Main/selfAccessRequest/adHoc/sameAs/SameAs_Footer.tpl.html';
import './Main/selfAccessRequest/adHoc/sameAs/SameAs_Header.tpl.html';
import './Main/selfAccessRequest/adHoc/SideBar.tpl.html';
import './Main/selfAccessRequest/adHoc/SideBarForSameAs.tpl.html';
import './Main/selfAccessRequest/adHoc/specialNeeds/OtherNeeds.tpl.html';
import './Main/selfAccessRequest/adHoc/submit/AdHocConfirmation.html';
import './Main/selfAccessRequest/arrival/Arrival.tpl.html';
import './Main/selfAccessRequest/arrival/ArrivalAdditionalSteps.html';
import './Main/selfAccessRequest/arrival/ArrivalCompleted.tpl.html';
import './Main/selfAccessRequest/arrival/locationEquipment/arrivalWelcome.tpl.html';
import './Main/selfAccessRequest/arrival/locationEquipment/LocationEquipment.tpl.html';
import './Main/selfAccessRequest/arrival/otherCatalog/OtherCatalog.tpl.html';
import './Main/selfAccessRequest/arrival/otherCatalog/OtherCatalogModal.tpl.html';
import './Main/selfAccessRequest/arrival/preAuthorized/NoDecisionsModal.tpl.html';
import './Main/selfAccessRequest/arrival/preAuthorized/PreAuthorized.tpl.html';
import './Main/selfAccessRequest/arrival/preAuthorized/PreAuthorized_FlowButtons.tpl.html';
import './Main/selfAccessRequest/arrival/preAuthorized/PreAuthorized_Header.tpl.html';
import './Main/selfAccessRequest/arrival/preAuthorized/PreAuthorizedExplanation1.tpl.html';
import './Main/selfAccessRequest/arrival/preAuthorized/PreAuthorizedExplanation2.tpl.html';
import './Main/selfAccessRequest/arrival/preAuthorizedDelta/NoDecisionsModal.tpl.html';
import './Main/selfAccessRequest/arrival/preAuthorizedDelta/PreAuthorizedDelta.tpl.html';
import './Main/selfAccessRequest/arrival/preAuthorizedDelta/PreAuthorizedDelta_Header.tpl.html';
import './Main/selfAccessRequest/arrival/sameAs/SameAs.tpl.html';
import './Main/selfAccessRequest/arrival/sameAs/SameAs_FlowButtons.tpl.html';
import './Main/selfAccessRequest/arrival/sameAs/SameAs_Header.tpl.html';
import './Main/selfAccessRequest/arrival/SideBar.tpl.html';
import './Main/selfAccessRequest/arrival/SideBarForSameAs.tpl.html';
import './Main/selfAccessRequest/arrival/specialNeeds/OtherNeeds.tpl.html';
import './Main/selfAccessRequest/arrival/submit/ArrivalSubmit.html';
import './Main/selfAccessRequest/contactInfoHelp.tpl.html';
import './Main/selfAccessRequest/noLongerSelfAccessRequest.tpl.html';
import './Main/selfAccessRequest/ownedByOtherUser.tpl.html';
import './Main/selfAccessRequest/SelfAccessRequest.tpl.html';
import './Main/staticHtmlPage/Main.tpl.html';
import './Main/supervisor/supervisorAccessReview/employeeCard.tpl.html';
import './Main/supervisor/supervisorAccessReview/noAccessReview.tpl.html';
import './Main/supervisor/supervisorAccessReview/noAccessReviewForEmployee.tpl.html';
import './Main/supervisor/supervisorAccessReview/notSubmittedModal.tpl.html';
import './Main/supervisor/supervisorAccessReview/SideBar_SystemToReview.tpl.html';
import './Main/supervisor/supervisorAccessReview/submitted.tpl.html';
import './Main/supervisor/supervisorAccessReview/Summary_SystemToReview.tpl.html';
import './Main/supervisor/supervisorAccessReview/systemToReview.tpl.html';
import './Main/supervisor/supervisorAccessReview/welcome.tpl.html';
import './Main/supervisor/supervisorAuthorizingUserRequest/CardSupervisorAuthorisingRequest.tpl.html';
import './Main/supervisor/supervisorAuthorizingUserRequest/displayBusinessTasks.tpl.html';
import './Main/supervisor/supervisorAuthorizingUserRequest/MainSupervisorAuthorizing.tpl.html';
import './Main/supervisor/supervisorAuthorizingUserRequest/NotAuthorizable.tpl.html';
import './Main/supervisor/supervisorAuthorizingUserRequest/NotAvailable.tpl.html';
import './Main/supervisor/supervisorAuthorizingUserRequest/NotSupervisor.tpl.html';
import './Main/supervisor/supervisorAuthorizingUserRequest/SelfRequestAsDelegate.tpl.html';
import './Main/supervisor/supervisorAuthorizingUserRequest/SupervisorAuthorizingRequest_Authorize.tpl.html';
import './Main/supervisor/supervisorAuthorizingUserRequest/SupervisorAuthorizingRequest_View.tpl.html';
import './Main/systemOwnerReview/Completed.tpl.html';
import './Main/systemOwnerReview/confirmSystemOwnership/BySystemType.tpl.html';
import './Main/systemOwnerReview/confirmSystemOwnership/BySystemType_Header.tpl.html';
import './Main/systemOwnerReview/confirmSystemOwnership/BySystemType_Navigation.tpl.html';
import './Main/systemOwnerReview/confirmSystemOwnership/ConfirmSystemOwnership.tpl.html';
import './Main/systemOwnerReview/confirmSystemOwnership/Explanation1.tpl.html';
import './Main/systemOwnerReview/confirmSystemOwnership/Explanation2.tpl.html';
import './Main/systemOwnerReview/confirmSystemOwnership/Explanation3.tpl.html';
import './Main/systemOwnerReview/confirmSystemOwnership/Explanation4.tpl.html';
import './Main/systemOwnerReview/confirmSystemOwnership/Explanation5.tpl.html';
import './Main/systemOwnerReview/confirmSystemOwnership/SideBar.tpl.html';
import './Main/systemOwnerReview/confirmSystemOwnership/SideBar_Actions.tpl.html';
import './Main/systemOwnerReview/confirmSystemOwnership/SideBar_Help.tpl.html';
import './Main/systemOwnerReview/confirmSystemOwnership/SideBar_SystemCatalog.tpl.html';
import './Main/systemOwnerReview/decommissionSystems/BySystemType.tpl.html';
import './Main/systemOwnerReview/decommissionSystems/BySystemType_Header.tpl.html';
import './Main/systemOwnerReview/decommissionSystems/BySystemType_Navigation.tpl.html';
import './Main/systemOwnerReview/decommissionSystems/DecommissionSystems.tpl.html';
import './Main/systemOwnerReview/decommissionSystems/Explanation1.tpl.html';
import './Main/systemOwnerReview/decommissionSystems/Explanation2.tpl.html';
import './Main/systemOwnerReview/decommissionSystems/Explanation3.tpl.html';
import './Main/systemOwnerReview/decommissionSystems/SideBar.tpl.html';
import './Main/systemOwnerReview/decommissionSystems/SideBar_Actions.tpl.html';
import './Main/systemOwnerReview/decommissionSystems/SideBar_Help.tpl.html';
import './Main/systemOwnerReview/decommissionSystems/SideBar_SystemCatalog.tpl.html';
import './Main/systemOwnerReview/decommissionSystems/summaryDecommissionSystemsModal.tpl.html';
import './Main/systemOwnerReview/GettingStarted.tpl.html';
import './Main/systemOwnerReview/MainSystemOwnerReview.tpl.html';
import './Main/systemOwnerReview/noReview.tpl.html';
import './Main/systemOwnerReview/reviewUniquePermissions/BySystemType.tpl.html';
import './Main/systemOwnerReview/reviewUniquePermissions/BySystemType_Header.tpl.html';
import './Main/systemOwnerReview/reviewUniquePermissions/BySystemType_Navigation.tpl.html';
import './Main/systemOwnerReview/reviewUniquePermissions/Explanation1.tpl.html';
import './Main/systemOwnerReview/reviewUniquePermissions/noSystemType.tpl.html';
import './Main/systemOwnerReview/reviewUniquePermissions/ReviewUniquePermissions.tpl.html';
import './Main/systemOwnerReview/reviewUniquePermissions/SideBar.tpl.html';
import './Main/systemOwnerReview/reviewUniquePermissions/SideBar_Actions.tpl.html';
import './Main/systemOwnerReview/reviewUniquePermissions/SideBar_Help.tpl.html';
import './Main/systemOwnerReview/reviewUniquePermissions/SideBar_SystemCatalog.tpl.html';
import './Main/systemOwnerReview/reviewUniquePermissions/UniquePermissionCard.tpl.html';
import './Main/systemOwnerUserRequest/CardNetworkShare.tpl.html';
import './Main/systemOwnerUserRequest/CardSystemRolePending.tpl.html';
import './Main/systemOwnerUserRequest/MainSystemOwnerUserRequest.tpl.html';
import './Main/userRequest/DisplayRequests.tpl.html';
import './Main/userRequest/LookupEmployee.tpl.html';
import './Main/userRequest/MainAccessRequest.tpl.html';
import './Main/userRequest/SideBar.tpl.html';
import './Main/userRequest/userRequestArrival/RequestArrival-ComputingDeviceBox.tpl.html';
import './Main/userRequest/userRequestArrival/RequestArrival-OfficeLocationBox.tpl.html';
import './Main/userRequest/userRequestArrival/RequestArrival-OtherEquipmentsBox.tpl.html';
import './Main/userRequest/userRequestArrival/RequestArrival-PermissionsBox.tpl.html';
import './Main/userRequest/userRequestArrival/RequestArrival.tpl.html';
import './Main/userRequest/userRequestArrival/RequestArrival_ErrorMessage.tpl.html';
import './Main/userRequest/userRequestEdit/Actions.tpl.html';
import './Main/userRequest/userRequestEdit/ActionSpecialSubmit.tpl.html';
import './Main/userRequest/userRequestEdit/ByBusinessTask.tpl.html';
import './Main/userRequest/userRequestEdit/ByBusinessTask_Allowables.tpl.html';
import './Main/userRequest/userRequestEdit/ByBusinessTask_Existings.tpl.html';
import './Main/userRequest/userRequestEdit/ByBusinessTask_SameAs.tpl.html';
import './Main/userRequest/userRequestEdit/ByNetworkShare.tpl.html';
import './Main/userRequest/userRequestEdit/ByNetworkShare_Allowables.tpl.html';
import './Main/userRequest/userRequestEdit/ByNetworkShare_Existings.tpl.html';
import './Main/userRequest/userRequestEdit/ByNetworkShare_Others.tpl.html';
import './Main/userRequest/userRequestEdit/ByNetworkShare_SameAs.tpl.html';
import './Main/userRequest/userRequestEdit/BySystemType.tpl.html';
import './Main/userRequest/userRequestEdit/BySystemType_Allowables.tpl.html';
import './Main/userRequest/userRequestEdit/BySystemType_Existings.tpl.html';
import './Main/userRequest/userRequestEdit/BySystemType_Others.tpl.html';
import './Main/userRequest/userRequestEdit/BySystemType_SameAs.tpl.html';
import './Main/userRequest/userRequestEdit/DisplayArrivalInformation.tpl.html';
import './Main/userRequest/userRequestEdit/DisplayEvents.tpl.html';
import './Main/userRequest/userRequestEdit/GettingStarted.tpl.html';
import './Main/userRequest/userRequestEdit/LocationEquipment.tpl.html';
import './Main/userRequest/userRequestEdit/Main.tpl.html';
import './Main/userRequest/userRequestEdit/MoreInfos.tpl.html';
import './Main/userRequest/userRequestEdit/NavigateBusinessTask.tpl.html';
import './Main/userRequest/userRequestEdit/NavigateSystemType.tpl.html';
import './Main/userRequest/userRequestEdit/NetworkShare.tpl.html';
import './Main/userRequest/userRequestEdit/SameAs.tpl.html';
import './Main/userRequest/userRequestEdit/selectEmployeeSameAsModal.tpl.html';
import './Main/userRequest/userRequestEdit/selectSystemRolesModal.tpl.html';
import './Main/userRequest/userRequestEdit/SideBar.tpl.html';
import './Main/userRequest/userRequestEdit/SideBarBusinessTasks.tpl.html';
import './Main/userRequest/userRequestEdit/SideBarSystems.tpl.html';
import './Main/userRequest/userRequestEdit/SideBar_Actions.tpl.html';
import './Main/userRequest/userRequestEdit/SideBar_Help.tpl.html';
import './Main/userRequest/userRequestEdit/systemAndRoles.tpl.html';
import './Main/userRequest/userRequestEdit/TaskCards.tpl.html';
import './Main/userRequest/userRequestEdit/TaskCatalog.tpl.html';
import './Main/userRequest/userRequestEdit/ValidationMessages.tpl.html';
import './Main/userRequest/userRequestEdit/ValidationMessages_Conflicts.tpl.html';
import './Main/userRequest/userRequestEdit/ValidationMessages_HighPrivileges.tpl.html';
import './Main/userRequest/userRequestEdit/ValidationMessages_MissingAdmAccount.tpl.html';
import './Main/userRequest/userRequestEdit/ValidationMessages_MissingSystemAccount.tpl.html';
import './Main/userRequest/userRequestEdit/ValidationMessages_NotEnoughPrivileges.tpl.html';
import './Main/userRequest/userRequestProcess/CardITPurchasingInstructions.tpl.html';
import './Main/userRequest/userRequestProcess/CardSystemRolePending.tpl.html';
import './Main/userRequest/userRequestProcess/ProcessRequest.tpl.html';
import './shared/templates/contentRestricted-full.tpl.html';
import './shared/templates/popover-large.tpl.html';
import './shared/templates/systemRoleAuthorizeException.tpl.html';
import './shared/components/controllers/employeeEvent/employeeEvents.tpl.html';
import './shared/components/controllers/employeeEvent/employeeEvents_AccessCardUpdate.tpl.html';
import './shared/components/controllers/employeeEvent/employeeEvents_Default.tpl.html';
import './shared/components/controllers/employeeEvent/employeeEvents_HRTransfer.tpl.html';
import './shared/components/controllers/employeeEvent/employeeEvents_PasswordReset.tpl.html';
import './shared/components/controllers/employeeEvent/employeeEvents_SystemAccountUpdate.tpl.html';
import './shared/components/controllers/selfAccessRequest/ConfirmRolesRequiringAdmAccountItem.Condensed.tpl.html';
import './shared/components/controllers/selfAccessRequest/ConfirmRolesRequiringAdmAccountItem.Default.tpl.html';
import './shared/components/controllers/selfAccessRequest/ConfirmRolesRequiringAdmAccountItem.NetworkShare.tpl.html';
import './shared/components/controllers/selfAccessRequest/ConfirmRolesRequiringAdmAccountModal.tpl.html';
import './shared/components/controllers/selfAccessRequest/SelectSameAsModal.tpl.html';
import './shared/components/controllers/systemOwner/SelectNewBackupSystemOwnerModal.tpl.html';
import './shared/components/controllers/systemOwner/selectNewPrimarySystemOwnerModal.tpl.html';
import './shared/components/controllers/systemOwner/SystemOwnerCard.tpl.html';
import './shared/components/controllers/topBar/topBar.tpl.html';
import './shared/components/directives/businessUnit.minimal.tpl.html';
import './shared/components/directives/businessUnitMember.minimal.tpl.html';
import './shared/components/directives/chooseAssign.tpl.html';
import './shared/components/directives/confirmClick.tpl.html';
import './shared/components/directives/datePicker.tpl.html';
import './shared/components/directives/displayAdditionalLicenseCost.tpl..html';
import './shared/components/directives/employeeDirective-asCard.tpl.html';
import './shared/components/directives/employeeDirective-default.tpl.html';
import './shared/components/directives/employeeDirective-defaultEntitlement.tpl.html';
import './shared/components/directives/employeeDirective-explorer.tpl.html';
import './shared/components/directives/employeeDirective-explorerNotEnoughPrivileges.tpl.html';
import './shared/components/directives/employeeDirective-full.tpl.html';
import './shared/components/directives/employeeDirective-fullForTransfer.tpl.html';
import './shared/components/directives/employeeDirective-ITPurchasing.tpl.html';
import './shared/components/directives/employeeDirective-listInModal.tpl.html';
import './shared/components/directives/employeeDirective-mini.tpl.html';
import './shared/components/directives/employeeDirective-miniOneLine.tpl.html';
import './shared/components/directives/employeeDirective-miniOneLineWithDepartment.tpl.html';
import './shared/components/directives/employeeDirective-navHeader.tpl.html';
import './shared/components/directives/employeeDirective-oneLine.tpl.html';
import './shared/components/directives/employeeDirective-oneLineFull.tpl.html';
import './shared/components/directives/employeeDirective-positionInHierarchy.tpl.html';
import './shared/components/directives/employeeDirective-profile.tpl.html';
import './shared/components/directives/employeeDirective-requestFor.tpl.html';
import './shared/components/directives/employeeDirective-requestForSupervisor.tpl.html';
import './shared/components/directives/employeeDirective-reviewEmployee.tpl.html';
import './shared/components/directives/employeeDirective-searchBox.tpl.html';
import './shared/components/directives/employeeDirective-supervisor.tpl.html';
import './shared/components/directives/employeeDirective_contactInfoTooltip.tpl.html';
import './shared/components/directives/empStagingDirective-exception-Error.tpl.html';
import './shared/components/directives/empStagingDirective-exception-Warning.tpl.html';
import './shared/components/directives/empStagingDirective-matching-confirmModal.tpl.html';
import './shared/components/directives/empStagingDirective-matching-default.tpl.html';
import './shared/components/directives/empStagingDirective-matching-default_details.tpl.html';
import './shared/components/directives/empStagingDirective-matching-default_header.tpl.html';
import './shared/components/directives/empStagingDirective-matching-DetectEmployeeArrival-confirmModal.tpl.html';
import './shared/components/directives/empStagingDirective-matching-DetectEmployeeArrival.tpl.html';
import './shared/components/directives/empStagingDirective-matching-DetectEmployeeContractRenewal.tpl.html';
import './shared/components/directives/empStagingDirective-matching-DetectEmployeeNewStatus-confirmModal.tpl.html';
import './shared/components/directives/empStagingDirective-matching-DetectEmployeeNewStatus.tpl.html';
import './shared/components/directives/empStagingDirective-matching-DetectEmployeeNewSupervisor-confirmModal.tpl.html';
import './shared/components/directives/empStagingDirective-matching-DetectEmployeeNewSupervisor.tpl.html';
import './shared/components/directives/empStagingDirective-matching-DetectEmployeePostDeparture.tpl.html';
import './shared/components/directives/empStagingDirective-matching-DetectEmployeeProperties.tpl.html';
import './shared/components/directives/empStagingDirective-matching-DetectEmployeeRehire-confirmModal.tpl.html';
import './shared/components/directives/empStagingDirective-matching-DetectEmployeeRehire.tpl.html';
import './shared/components/directives/empStagingDirective-matching-DetectEmployeeUpdatePendingProperties.tpl.html';
import './shared/components/directives/empStagingDirective-matching-DetectEmployeeUpdateProperties.tpl.html';
import './shared/components/directives/empStagingDirective-matching-footerActions.tpl.html';
import './shared/components/directives/empStagingDirective-matching-otherStaging.tpl.html';
import './shared/components/directives/empStagingDirective-matching-otherStagingList.tpl.html';
import './shared/components/directives/iamEventDirective-default.tpl.html';
import './shared/components/directives/iamEventDirective-default_CONFIRM_ONBOARDING_BY_SERVICEDESK_PENDING.tpl.html';
import './shared/components/directives/iamEventDirective-default_CREATE_DEPARTURE_ACCESS_REQUEST_INITIATE.tpl.html';
import './shared/components/directives/iamEventDirective-default_CREATE_DEPARTURE_ACCESS_REQUEST_REQUESTED.tpl.html';
import './shared/components/directives/iamEventDirective-default_EventName.tpl.html';
import './shared/components/directives/iamEventDirective-default_ON_HOLD_TO_PROCESS_ACCESS_REQUESTS_PENDING.tpl.html';
import './shared/components/directives/iamEventDirective-default_PROCESS_TRANSFER_OR_NO_ACCESS_CHANGES_REQUIRED_PENDING.tpl.html';
import './shared/components/directives/iamEventDirective-default_PUBLISH2ADSS_ADD_PERMISSION_TO_ACCOUNT_INITIATE.tpl.html';
import './shared/components/directives/iamEventDirective-default_PUBLISH2ADSS_CREATE_OR_REACTIVATE_ACCOUNT_INITIATE.tpl.html';
import './shared/components/directives/iamEventDirective-default_PUBLISH2ADSS_CREATE_OR_REACTIVATE_ACCOUNT_NEED_RETRY.tpl.html';
import './shared/components/directives/iamEventDirective-default_PUBLISH2ADSS_DELETE_ACCOUNT_INITIATE.tpl.html';
import './shared/components/directives/iamEventDirective-default_PUBLISH2ADSS_DELETE_ACCOUNT_NEED_RETRY.tpl.html';
import './shared/components/directives/iamEventDirective-default_PUBLISH2ADSS_SYNCHRONIZE_ACCOUNT_INITIATE.tpl.html';
import './shared/components/directives/iamEventDirective-default_PUBLISH2ADSS_SYNCHRONIZE_ACCOUNT_NEED_RETRY.tpl.html';
import './shared/components/directives/iamEventDirective-default_PUBLISH2ESB_EMPLOYEE_INITIATE.tpl.html';
import './shared/components/directives/iamEventDirective-default_PUBLISH2ESB_EMPLOYEE_NEED_RETRY.tpl.html';
import './shared/components/directives/iamEventDirective-default_SEND_INITIAL_PASSWORD_TO_EMPLOYEE_INITIATE.tpl.html';
import './shared/components/directives/iamEventDirective-default_SEND_INITIAL_PASSWORD_TO_EMPLOYEE_NEED_RETRY.tpl.html';
import './shared/components/directives/iamEventDirective-default_TaskError.tpl.html';
import './shared/components/directives/iamEventDirective-group.tpl.html';
import './shared/components/directives/iamEventDirective-groupHistory.tpl.html';
import './shared/components/directives/iamEventDirective-groupSummary.tpl.html';
import './shared/components/directives/iamEventDirective-groupSummary_Default.tpl.html';
import './shared/components/directives/iamEventDirective-groupSummary_Transfer.tpl.html';
import './shared/components/directives/personDirective-default.tpl.html';
import './shared/components/directives/personDirective-eventFollowUp.tpl.html';
import './shared/components/directives/personDirective-facet.tpl.html';
import './shared/components/directives/personDirective-medium.tpl.html';
import './shared/components/directives/personDirective-mini-calendar.tpl.html';
import './shared/components/directives/personDirective-mini-emailAddress.tpl.html';
import './shared/components/directives/personDirective-mini.tpl.html';
import './shared/components/directives/personDirective-navBoxItem.tpl.html';
import './shared/components/directives/personDirective-navHeader.tpl.html';
import './shared/components/directives/personDirective-searchBox.tpl.html';
import './shared/components/directives/personDirective-small.tpl.html';
import './shared/components/directives/personDirective-smallTwoLines.tpl.html';
import './shared/components/directives/selectPersonModal.tpl.html';
import './shared/components/directives/selfAccessRequestDecision.Condensed.tpl.html';
import './shared/components/directives/selfAccessRequestDecision.condensedItem.tpl.html';
import './shared/components/directives/selfAccessRequestDecision.Default.tpl.html';
import './shared/components/directives/selfAccessRequestDecision.item.tpl.html';
import './shared/components/directives/selfAccessRequestDecision.itemReadOnly.tpl.html';
import './shared/components/directives/selfAccessRequestDecision.networkItem.tpl.html';
import './shared/components/directives/selfAccessRequestDecision.networkItemReadOnly.tpl.html';
import './shared/components/directives/selfAccessRequestDecision.NetworkShare.tpl.html';
import './shared/components/directives/systemsOwnedDecommissionPermissions.tpl.html';
import './shared/components/directives/systemsOwnershipGroups.tpl.html';
import './shared/components/directives/systemsOwnershipManageNewGroup.tpl.html';
import './shared/components/directives/userRequest.box-infos.tpl.html';
import './shared/components/directives/userRequest.in-list.tpl.html';
import './shared/components/directives/userRequestFollowups.full.tpl.html';
import './shared/components/directives/userRequestFollowups.last.tpl.html';
import './shared/components/directives/userRequestNotStartedActions.tpl.html';
import './shared/components/directives/userRequestStartedActions.tpl.html';
import './shared/components/helpers/staticMessageCtrl.tpl.html';
